import React from 'react';
import { motion } from 'framer-motion';
import * as FaIcons from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';

const { FaTiktok } = FaIcons;

const Footer = () => {
  return (
    <footer className="bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col items-center justify-center space-y-4">
          <div className="flex items-center space-x-4">
            <p className="text-gray-600 dark:text-gray-400 text-sm text-center">
              MentIAx © 2025-2026 Alfredo Menéndez
            </p>
            
            <motion.a
              href="https://www.tiktok.com/@alfredmenendez"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              title="Síguenos en TikTok"
            >
              <SafeIcon icon={FaTiktok} className="w-5 h-5 text-black dark:text-white" />
            </motion.a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;